import type { RouteRecordRaw } from "vue-router";

export const teachingBoardRoutes: RouteRecordRaw[] = [
  {
    path: "/teaching_board/info",
    name: "classroom_screen-info",
    component: () => import("./info/TeachingBoardInfoPage.vue"),
    meta: {
      namespace: "classroom_screen",
      title: "tools_meta.teaching_board_prefix",
    },
  },
  {
    path: "/teaching_board/screens",
    name: "classroom_screen-index",
    component: () => import("./screens/ScreenListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "classroom_screen",
      title: "tools_meta.teaching_board_prefix",
    },
  },
  {
    path: "/teaching_board/screens/:id",
    name: "classroom_screen-show",
    component: () => import("./screens/ScreenLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "classroom_screen",
      title: "tools_meta.teaching_board_prefix",
    },
    children: [
      {
        path: "pages/:pageId",
        name: "classroom_screen-page-show",
        component: () => import("./screens/[id]/pages/ScreenPageLayout.vue"),
        meta: {
          title: "tools_meta.teaching_board_prefix",
        },
        children: [
          {
            path: "author_info",
            name: "classroom_screen-author-info",
            component: () =>
              import("./screens/[id]/pages/[pageId]/author_info/ScreenPageAuthorInfoPage.vue"),
            meta: {
              title: "tools_meta.teaching_board_prefix",
            },
          },
          {
            path: "settings",
            name: "classroom_screen-settings",
            component: () =>
              import("./screens/[id]/pages/[pageId]/settings.vue"),
            meta: {
              requiresAuth: true,
              namespace: "classroom_screen",
              title: "tools_meta.teaching_board_prefix",
            },
          },
          {
            path: "share",
            name: "classroom_screen-share",
            component: () => import("./screens/[id]/pages/[pageId]/share.vue"),
            meta: {
              requiresAuth: true,
              namespace: "classroom_screen",
              title: "tools_meta.teaching_board_prefix",
            },
          },
          {
            path: "theme",
            name: "classroom_screen-page-theme",
            component: () =>
              import("./screens/[id]/pages/[pageId]/theme/ScreenPageThemePage.vue"),
            meta: {
              title: "tools_meta.teaching_board_prefix",
            },
          },
        ],
      },
    ],
  },
  // Public screens
  {
    path: "/teaching_board/public_screens/:id",
    name: "classroom_screen-public-show",
    component: () => import("./public_screens/PublicScreenLayout.vue"),
    meta: {
      namespace: "classroom_screen",
      title: "tools_meta.teaching_board_prefix",
    },
    children: [
      {
        path: "pages/:pageId",
        name: "classroom_screen-public-page-show",
        component: () =>
          import("./public_screens/[id]/pages/PublicScreenPageLayout.vue"),
        meta: {
          title: "tools_meta.teaching_board_prefix",
        },
        children: [
          {
            path: "author_info",
            name: "classroom_screen-public-author-info",
            component: () =>
              import("./public_screens/[id]/pages/[pageId]/author_info/PublicScreenPageAuthorInfoPage.vue"),
            meta: {
              title: "tools_meta.teaching_board_prefix",
            },
          },
        ],
      },
    ],
  },
];
